export default {
    id: 'oceanic',
    colors: ['#050189', '#AEF8FE'],
};
